import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  input: {
    width: 57,
  },
  progressText: {
    padding: '0 12px',
  },
  slider: {
    padding: 'var(--slider-inner-y-gap) var(--slider-inner-x-gap) var(--slider-inner-y-gap) 0',
  },
});

export default useStyles;
